import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'common-description-preview',
  templateUrl: './description-preview.component.html',
  styleUrls: ['./description-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionPreviewComponent implements OnChanges {
  @Input() value = '';
  @Input() emptyText = '—';
  /** Etiqueta superior (misma semántica que `common-input-preview`). */
  @Input() label = '';
  @Input() showLabel = false;
  @Input() showLeadingIcon = false;
  @Input() leadingIcon = 'person';
  @Input() showEditIcon = false;
  @Input() borderless = false;
  /** Cuando es true, clic en la fila emite `edit` (aunque `showEditIcon` sea false). */
  @Input() clickable = false;
  /**
   * Alineación vertical del botón de edición respecto a la fila flex.
   * `center`: mismo criterio que `common-input-preview` (centra en el alto del contenido).
   * `start`: `align-self: flex-start` para alinear con la primera línea cuando el HTML es alto (p. ej. junto a otros input-preview).
   */
  @Input() editIconVerticalAlign: 'center' | 'start' = 'center';

  @Output() edit = new EventEmitter<void>();

  public containerClasses: string[] = [];

  get hasValue(): boolean {
    const raw = String(this.value ?? '').trim();
    if (!raw) return false;
    const text = raw
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return text.length > 0;
  }

  constructor() {
    this.syncContainerClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['borderless'] || changes['clickable']) {
      this.syncContainerClasses();
    }
  }

  onEdit(): void {
    this.edit.emit();
  }

  onClick(): void {
    if (!this.clickable) return;
    this.onEdit();
  }

  private syncContainerClasses(): void {
    const next: string[] = [];
    if (this.borderless) next.push('munily-input-preview--borderless');
    if (this.clickable) next.push('munily-input-preview--clickable');
    this.containerClasses = next;
  }
}
